<script>
import Swiper from 'swiper'
import {
  computed, onMounted, reactive, ref
} from 'vue'
import searchQueryState from '@/compositions/search/SearchQuery'

export default {
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    let slider
    const sliderRef = ref(null)

    const state = reactive({
      isSliderActive: false
    })

    const {
      addCategory,
      removeCategory,
      searchQuery
    } = searchQueryState.searchQueryUse()

    const categories = computed(() => props.category.categories.map((c) => {
      const active = searchQuery.activeCategories?.some((a) => a.uid === c.uid)
      return { ...c, active }
    }))
    const activeCount = computed(() => categories.value.filter((c) => c.active).length)
    const isDefaultView = computed(() => categories.value.length < 3)

    function initSlider() {
      const settings = {
        initialSlide: 0,
        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 16
      }

      slider = new Swiper(sliderRef.value, settings)
      state.isSliderActive = true
    }

    function onCategoryExpand() {
      if (slider) {
        slider.destroy()
        slider = null
        state.isSliderActive = false
      } else {
        initSlider()
      }
    }

    function getChildCategoryName(childCategory) {
      return childCategory.name.split('_')[1]
    }

    function onChangeCategory(category) {
      if (!category.active) {
        addCategory(category)
      } else {
        removeCategory(category)
      }
    }

    onMounted(() => {
      if (!isDefaultView.value) {
        initSlider()
      }
    })

    return {
      state,
      categories,
      activeCount,
      sliderRef,
      onCategoryExpand,
      onChangeCategory,
      isDefaultView,
      getChildCategoryName
    }
  }
}
</script>

<!--<style>-->
<!--.swiper-slide {-->
<!--  @apply w-auto;-->
<!--}-->
<!--</style>-->
